import { render, staticRenderFns } from "./BankStatementsSearch.vue?vue&type=template&id=7166063c&scoped=true&"
import script from "./BankStatementsSearch.vue?vue&type=script&lang=js&"
export * from "./BankStatementsSearch.vue?vue&type=script&lang=js&"
import style0 from "./BankStatementsSearch.vue?vue&type=style&index=0&id=7166063c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166063c",
  null
  
)

export default component.exports